import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import sentry from 'legacy/utils/sentry'

import { ProposalRepository } from '../infra/ProposalRepository'

export type GetRfpHistoryFactoryDependencies = {
  repository: ProposalRepository
}

export function getRfpHistoryFactory({ repository }: GetRfpHistoryFactoryDependencies) {
  return async function get(config?: { signal?: AbortSignal }) {
    try {
      return await repository.getRfpHistory(config)
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not get RFP history', { cause: error as Error })
    }
  }
}

export function getRfpHistory(config?: { signal?: AbortSignal }) {
  const httpClient = new HttpClient(API_URL)
  const repository = new ProposalRepository({ httpClient })
  const get = getRfpHistoryFactory({ repository })
  return get(config)
}
